import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Login from "./Pages/LoginPage";
import { localUrlEnum } from "./Utils/UrlEnum";
import Loading from "./Utils/Loading";
import CustomThemeProvider from "./Context/CustomThemeProvider";
import LocalRouter from "./Router/LocalRouter";
import { WebsocketProvider } from "./Context/WebSocketContext";
import PageNotFound from "./Components/PageNotFound";
import { Vocabulary } from "./Utils/Vocabulary";
import { DrawerStateContextProvider } from "./Context/DrawerStateContext";
import { TaskContextProvider } from "./Context/TaskContext";
import { RefreshDataContextProvider } from "./Context/RefreshDataContext";
import ForgotPassword from "./Pages/ForgotPasswordPage";
import ResetPassword from "./Pages/ResetPasswordPage";

import PublicRegistration from "./Components/PublicRegistration/PublicRegistration";
import OrderStatusPage from "./Components/PublicRegistration/PaymentStatusPage";
import ClientRegistrationPage from "./Components/ClientRegistration/ClientRegistrationPage";
import SubscriptionExpiredPage from "./Components/PublicRegistration/SubscriptionExpiredPage";

export default function App() {
  return (
    <CustomThemeProvider>
      <WebsocketProvider>
        <RefreshDataContextProvider>
          <DrawerStateContextProvider>
            <TaskContextProvider>
              <ToastContainer
                style={{ zIndex: 99999 }}
                hideProgressBar={true}
              />
              {window.localStorage.getItem("userRoles") ? (
                <LocalRouter name={"LocalRouter"} />
              ) : (
                <BrowserRouter>
                  <Routes>
                    <Route path={localUrlEnum.login} element={<Login />} />
                    <Route
                      path={localUrlEnum.publicRegistration}
                      element={
                        localStorage.getItem("no-cookie") === "1" ? (
                          <Navigate to={localUrlEnum.login} replace />
                        ) : (
                          <PublicRegistration />
                        )
                      }
                    />
                    <Route
                      path={localUrlEnum.clientRegistration}
                      element={
                        localStorage.getItem("no-cookie") === "1" ? (
                          <Navigate to={localUrlEnum.login} replace />
                        ) : (
                          <ClientRegistrationPage />
                        )
                      }
                    />
                    <Route
                      path={localUrlEnum.paymentStatus}
                      element={<OrderStatusPage />}
                    />
                    <Route
                      path={localUrlEnum.subscriptionExpired}
                      element={<SubscriptionExpiredPage />}
                    />
                    <Route path={localUrlEnum.mainRoute} element={<Login />} />
                    <Route
                      path={localUrlEnum.forgotPassword}
                      element={<ForgotPassword />}
                    />
                    <Route
                      path={localUrlEnum.resetPassword}
                      element={<ResetPassword />}
                    />
                    <Route
                      path={localUrlEnum.orderStatusPage}
                      element={<OrderStatusPage />}
                    />
                    <Route
                      path={"/*"}
                      element={<PageNotFound text={Vocabulary.pageNotFound} />}
                    />
                  </Routes>
                </BrowserRouter>
              )}
              <Loading />
            </TaskContextProvider>
          </DrawerStateContextProvider>
        </RefreshDataContextProvider>
      </WebsocketProvider>
    </CustomThemeProvider>
  );
}
